import React from 'react';
import { formatDate } from '@utils/formatter';
import { CapaQuotationPartnerTechnologyModel } from '@generated/graphql';
import DetailViewDialog from '../DetailViewDialog';
import ListItem from './ListItem';

const CertificateDetailInformation: React.FunctionComponent<{
  certificate: CapaQuotationPartnerTechnologyModel;
}> = ({ certificate }) => {
  return (
    <DetailViewDialog.Informaiton
      projectName={certificate.technicalName ?? ''}
      description={certificate.description ?? undefined}
      content={
        <>
          <ListItem
            label="발급 기관"
            value={certificate.certificationAuthority}
          />
          <ListItem
            label="유효 기간"
            value={
              certificate.expirationPeriodStart &&
              certificate.expirationPeriodEnd
                ? `${formatDate(
                    new Date(
                      certificate.expirationPeriodStart ?? ''
                    ).toString(),
                    'YYYY.MM.DD'
                  )} ~ ${formatDate(
                    new Date(certificate.expirationPeriodEnd ?? '').toString(),
                    'YYYY.MM.DD'
                  )}`
                : undefined
            }
          />
        </>
      }
    />
  );
};

export default CertificateDetailInformation;
